export const ApplicationRoutes = [
    {
        path: `:category`,
        components: {
            "service-application": () => import(/* webpackChunkName: "service-application" */ "../components/client/center/service-application/ApplicationListPage.vue"),
        },
        props: {
            "service-application": (route) => ({ category: route.params.category }),
        },
    },
    {
        path: `:category/:_application`,
        components: {
            "service-application": () => import(/* webpackChunkName: "service-application" */ "../components/client/center/service-application/ApplicationViewPage.vue"),
        },
        props: {
            "service-application": (route) => ({ category: route.params.category, _application: route.params._application }),
        },
    },
    {
        path: `:category/:_application/modify`,
        components: {
            "service-application": () => import(/* webpackChunkName: "service-application" */ "../components/client/center/service-application/ApplicationInputPage.vue"),
        },
        props: {
            "service-application": (route) => ({ category: route.params.category, _application: route.params._application }),
        },
    },
];
